import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';

import { DailyRegistrationForm } from '../../components';
import Modal from '../../containers/Modal';
import useClasses from '../../hooks/useClasses';
import useRoutes from '../../hooks/useRoutes';
import useToast from '../../hooks/useToast';
import type { LocationState } from '../../types';
import useTypedDispatch from '../../hooks/useTypedDispatch';
import { createRegistration } from '../../store/actions/Registrations';
import { viewGet } from '../../store/actions/Entity/View';

const PageDailyRegistration: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useTypedDispatch();
  const { recoveryPlan } = useRoutes();
  const location = useLocation();
  const { buildClass } = useClasses('PageDailyRegistration');
  const toast = useToast();

  const [isLoading, setLoading] = React.useState(false);
  const prevRoute = (location.state as LocationState)?.prevRoute;

  return (
    <Modal
      modalVisible
      className={buildClass()}
      title={t('pages.daily_registration.title')}
      closeModal={() => {
        // TODO: check if the last page was on either the dashboard or daily registrations
        // page. If so, do history.goBack(), otherwise push to one of these pages.
        // Always using history.goBack() could result in an edge case in which the user
        // is redirected to a page on a different host (i.e. they accessed the daily registration
        // using an URL). This would cause unexpected behaviour.
        history.push(prevRoute ?? recoveryPlan);
      }}
    >
      <div className="col-lg-8 offset-lg-2">
        <DailyRegistrationForm
          isLoading={isLoading}
          onSubmit={(values) => {
            setLoading(true);

            const mappedData = {
              registration_date: values.date,
              amount: String(values.frequency),
              cost: values.cost,
              where: values.where,
              with_who: values.withWho,
              note: values.note,
            };

            dispatch(createRegistration(mappedData)).then(() => {
              toast.show(t('pages.daily_registration.success_message'), 'success');
              // Refresh the diary overview.
              if (values.note) {
                dispatch(viewGet('diary_overview', 'block_1'));
              }
              history.push(prevRoute ?? recoveryPlan);
            }).catch((error) => {
              toast.show(t('pages.daily_registration.error_message'), 'error');
              console.error(error);
            }).finally(() => setLoading(false));
          }}
        />
      </div>
    </Modal>
  );
};

export default PageDailyRegistration;
